<template>
  <div>

    <div class="details-banner" v-if="!bannerImg">
      <div class="details-intro">
        <el-row>
          <el-col :span="24">
            <div class="title">{{ title }}</div>
          </el-col>
          <el-col :xs="24" :md="16" :lg="18">
            <div class="subtitle">{{ subtitle }}</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <img :src="bannerImg" style="width: 100%;margin-top: 64px" v-if='sourceType === "img" && bannerImg' />
    <video id="" autoplay muted loop preload="auto" style="z-index: 200; width: 100%; height: auto;;margin-top: 64px"
      v-if='sourceType === "video" && video'>
      <source type="video/mp4" :src="video" />
    </video>
    <div class="details-container">
      <div class="contant">
        <el-tabs v-model="activeName" @tab-click="getList">
          <el-tab-pane label="平台资讯" name="PT_CONSULT">
            <el-empty v-if="!list.length" description="暂无资讯"></el-empty>
            <el-row v-for="(item, index) in list" :key="index" :gutter="20" style="margin-top: 40px">
              <el-col :xs="24" :md="6">
                <img :src="item.thumbnail" style="width: 100%">
              </el-col>
              <el-col :xs="24" :md="18" class="contant-right">
                <div @click="handleDetailsClick(item)">
                  <div class="title">{{ item.title }}</div>
                  <div class="desc">{{ item.riefIntroduction }}</div>
                  <!-- <span class="time">{{ item.time }}</span> -->
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="行业新闻" name="PT_NEWS">
            <el-empty v-if="!list.length" description="暂无新闻"></el-empty>
            <el-row v-for="(item, index) in list" :key="index" :gutter="20" style="margin-top: 40px">
              <el-col :xs="24" :md="6">
                <img :src="item.thumbnail" style="width: 100%">
              </el-col>
              <el-col :xs="24" :md="18" class="contant-right">
                <div @click="handleDetailsClick(item)">
                  <div class="title">{{ item.title }}</div>
                  <div class="desc">{{ item.riefIntroduction }}</div>
                  <!-- <span class="time">{{ item.time }}</span> -->
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
        <div>
          <el-pagination background hide-on-single-page :page-size.sync="queryParams.pageSize"
            :current-page.sync="queryParams.pageNum" layout="prev, pager, next" :total="total"
            @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getConsultList } from '@/api/consult'
import { listBanner } from '@/api'
export default {
  name: "information",
  data () {
    return {
      activeName: 'PT_CONSULT',
      title: '平台资讯',
      subtitle: 'Environmental industry ecological partner',
      list: [],
      total: undefined,
      queryParams: {
        articleType: undefined,
        pageNum: 1,
        pageSize: 3
      },
      sourceType: 'img',
      bannerImg: ''
    }
  },
  mounted () {
    this.getList()
    // 获取banner数据
    this.getBanner()
  },
  methods: {
    async getBanner () {
      const res = await listBanner({ bannerPosition: 'PTZX_BANNER', useFlag: '1' })
      const data = res.rows.find(v => (v.bannerImg && v.sourceType == 'img') || (v.video && v.sourceType == 'video'))
      if (!data) return
      this.sourceType = data.sourceType
      this.bannerImg = data.bannerImg
      this.video = data.video
    },
    getList () {
      this.queryParams.articleType = this.activeName
      getConsultList(this.queryParams).then(res => {
        this.list = res.rows
        this.total = res.total
      })
    },
    handleDetailsClick (item) {
      this.$router.push({ path: '/ConsultDetails', query: { id: item.id, name: this.activeName } })
    },
    handleCurrentChange (val) {
      this.queryParams.pageNum = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-pagination {
  text-align: center;
  margin-top: 30px;
}

.details-banner {
  /* width: 100%;
  height: 450px;
  background: #20252f;
  position: relative; */

  .details-intro {
    width: 75%;
    position: absolute;
    top: 40%;
    left: 12%;
    color: #ffffff;

    .title {
      font-size: 36px;
      font-weight: 500;
      margin-bottom: 15px;
    }

    .subtitle {
      opacity: 0.8;
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
    }
  }
}

.details-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .contant {
    width: 75%;
    margin: 70px 0;

    .contant-right {
      cursor: pointer;

      .title {
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 10px;
      }

      .desc {
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        color: rgba(19, 20, 21, 0.60);
        margin-bottom: 10px;
      }

      .time {
        font-size: 14px;
        font-weight: 500;
        color: rgba(19, 20, 21, 0.60);
      }

      &:hover {
        color: #E50009;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Information.vue